<script setup lang="ts">
defineProps<{
  message: string
}>()
</script>

<template>
  <p class="form-error">
    <Icon name="fa6-solid:circle-exclamation" />
    {{ message }}
  </p>
</template>

<style lang="scss" scoped>
.form-error {
  color: var(--app-color-error-red);
}
</style>
